import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionAmenities } from "./amenities";
import { QuestionHotelPolicyFacilities } from "./facilities";

import type { HotelPolicyCategoriesAndManagerStore } from "../../../../store/categories";

type Props = {
	amenities: HotelPolicyCategoriesAndManagerStore["amenities"];
};

export const QuestionHotelPolicyAmenities = ({ amenities }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={amenities}>
			<QuestionAmenities />
			<QuestionHotelPolicyFacilities />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionHotelPolicyAmenities.displayName = "QuestionHotelPolicyAmenities";
